import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  NextButton,
  QuestionPageContainer,
  FormContainer,
  Prompt,
  QuestionContainer,
} from "~/OnboardingApp/components";
import { Trans } from "~/utils/i18next";
import { InputSection } from "./components";
import { useSignUpForm } from "./useSignUpForm";

export const EmailPage: FC = () => {
  const { t } = useTranslation();
  const { errorMessage, formik } = useSignUpForm();
  const { setErrors } = formik;

  useEffect(() => {
    if (!errorMessage) return;

    setErrors({ email: errorMessage });
  }, [errorMessage, setErrors]);

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt
            description={t("onboarding.emailPage.description")}
            question={
              <Trans
                i18nKey="onboarding.emailPage.question"
                values={{ name: formik.values.firstName }}
              />
            }
          />

          <InputSection />
        </QuestionContainer>

        <NextButton />
      </FormContainer>
    </QuestionPageContainer>
  );
};
